import Http from '@mlz/axios';
import { errorParse } from './errorParse';
const config = window.CODEMAOCONFIG; // 项目不同环境的配置文件

// 设置全局响应拦截
Http.setResInterceptor(
  (response) => {
    const { data } = response;
    if (/^2\d/.test(response.status.toString())) {
      try {
        response.status = data.stateCode?.code || 200;
      } catch (e) {
        throw new Error(`接口错误：${e}`);
      }
    }
    return response;
  },
  (error) => {
    if (error.response && error.response.data) {
      const { data } = error.response;
      const code = data.stateCode?.code;
      throw new Error(errorParse(code));
    }
  },
);

export const IntroduceApi = new Http(config.introduce);
export const InternalApi = new Http(config.internal);
export const MarketApi = new Http(config.market);
export const Api = new Http(config.api);
